import EducationEdit from "../Edits/EducationEdit";
import CmModal from "../Controls/CmModal";

export default function EducationEditModal({ educationId = 0, onClose }) {
  const id = Number.parseInt(educationId, 10) || 0;
  const title = id > 0 ? "Education" : "Add Education";

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="form"
      testId="education-edit-modal"
    >
      <EducationEdit educationId={id} onClose={onClose} />
    </CmModal>
  );
}
